'use client'

import { QUERY_KEYS } from '@/hooks/react-query/constants'
import { __cExchangeService } from '@/services/client/__c.exchange.service'
import { useQuery } from '@tanstack/react-query'
import { getCookie } from 'cookies-next'

export const useWebOrdersQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.WEB_ORDERS],
    queryFn: () => __cExchangeService.getWebOrders(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    // only call api if token is present
    enabled: !!getCookie(process.env.NEXT_PUBLIC_TOKEN_KEY),
  })
}
